/**
 * Contains ps4 application lifecycle names to which listeners will be added by users of the SDK. It is an object
 * containing application lifecycle event names each pointing to an array of listeners to be
 * called when the lifecycle event happens
 * @type {Object}
 * @private
 */
export const appLifecycleListeners = {
  deepLink: [], // This event is the generic name the SDK provides for Eden
  visibilitychange: []
};
